import Autocomplete from "@material-ui/lab/Autocomplete";
import { FormControl, Box, TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useFetchDistinctFieldValuesQuery } from "../../../CohortApi";

export const AutocompleteRenderer = ({
    config,
    rule,
    idx,
    handleUpdateRule,
    nestedField
}) => {
    const [hasFocused, setHasFocused] = useState(false);
    const shouldFetch = config.autoLoadValues && hasFocused;
    const {data: autoLoadedFieldValues = [], isLoading} = useFetchDistinctFieldValuesQuery({ field: rule.properties.field, nested: nestedField }, {skip: !shouldFetch, refetchOnReconnect: true });
    const { t } = useTranslation();
    const values = (config.autoLoadValues? autoLoadedFieldValues : config.values).filter(v => v !== "");
    return (
        <Box key={idx} display="flex" flexDirection="row" alignItems="center" style={{ gap: "10px" }}>
            <Box display="flex" flexDirection="row" alignItems="center">
                {config.compact ? null : <div>{config.label || rule.properties.field}</div>}
            </Box>
            <Box display="flex" flexDirection="column">
                <FormControl size="small">
                    <Autocomplete
                        freeSolo
                        options={values}
                        value={rule.properties.value}
                        size="small"
                        loading={shouldFetch && isLoading}
                        loadingText={t("global.loading") + "..."}
                        onFocus={() => setHasFocused(true)}
                        onInputChange={(e, value) => {
                            handleUpdateRule(idx, {
                                ...rule.properties,
                                value,
                            });
                        }}
                        filterOptions={(options) =>
                            options.filter((option) =>
                                option.toLowerCase().includes(rule.properties.value.toLowerCase())
                            )
                        }
                        disableClearable
                        renderInput={(params) => {
                            return (
                                <TextField
                                size="small"
                                    {...params}
                                    placeholder=""
                                    onChange={params.onChange}
                                    value={params.value}
                                    InputProps={{
                                        ...params.InputProps,
                                        style: {
                                            marginTop: 0,
                                        }
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                        style: {
                                            position: 'absolute',
                                            top: '-15px'
                                        }
                                    }}
                                    label={t(config.label) || rule.properties.field}
                                    style={{width: config.width ? config.width + 'px' : undefined}}
                                />
                            );
                        }}
                    />
                </FormControl>
            </Box>
        </Box>
    );
};
